// Функция для формирования строки во множественной форме на казахском языке
export default function kkPluralize(number, strings) {
    // Проверяем, есть ли у нас три формы (0, 1, множественная)
    if (strings.length === 3) {
        // Если число равно 0, возвращаем форму для нуля
        if (number === 0) {
            return strings[0];
        }

        // Удаляем первый элемент (форму для 0), так как она нам больше не нужна
        strings.shift();
    }

    // Если число равно 1, возвращаем форму для единственного числа
    if (number === 1) {
        return strings[0];
    }

    // Возвращаем форму для множественного числа (2 и более)
    return strings[1];
}